var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorCareful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.0151 108H20.9826C16.8051 108 13.0001 105.878 10.8026 102.323C8.60259 98.765 8.40509 94.405 10.2751 90.665L10.3276 90.5625L50.3051 17.67C52.2226 14.1725 55.9376 12 60.0001 12C64.0626 12 67.7776 14.1725 69.6951 17.67L109.52 90.2775C111.568 94.035 111.485 98.4675 109.305 102.14C107.125 105.81 103.278 108 99.0126 108H99.0151ZM15.6201 93.3925C14.7101 95.25 14.8176 97.405 15.9051 99.1675C17.0176 100.968 18.8676 102 20.9826 102H99.0151C101.143 102 103.06 100.908 104.148 99.0775C105.238 97.2425 105.278 95.03 104.258 93.1575L64.4351 20.555C63.5576 18.955 61.9001 18 60.0001 18C58.1001 18 56.4426 18.955 55.5651 20.555L15.6201 93.3925Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45H54V69H66V45Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93C64.9706 93 69 88.9706 69 84C69 79.0294 64.9706 75 60 75C55.0294 75 51 79.0294 51 84C51 88.9706 55.0294 93 60 93Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCareful);
export default __webpack_public_path__ + "static/media/Error_Careful.c225ad43.svg";
export { ForwardRef as ReactComponent };